import React, { useEffect, useState } from "react";
import "../../css/ShopOfferCreateScreen.css";
import { useNavigate } from "react-router-dom";
import OfferTemplateRenderer from "../../components/offerDetails/offerTemplates/OfferTemplateRenderer";
import { uploadImageToCloudinaryStorage } from "../../config/uploadImageToCloudinaryStorage";
import CreateOfferDetailsComp from "../../components/adminDashboard/CreateOfferDetailsComp";
import CreatePricingDetailsComp from "../../components/adminDashboard/CreatePricingDetailsComp";
import TermsAndConditionsComp from "../../components/adminDashboard/TermsAndConditionsComp";
import ValidityComp from "../../components/adminDashboard/ValidityComp";
import CreateOfferDetailsInfoPreview from "../../components/adminDashboard/CreateOfferDetailsInfoPreview";
import ImageCropper from "../../components/adminDashboard/ImageCropper";
import { getShopDetailsFromLocalStorage } from "../../localstorage";
import {
	checkShopOfferLimit,
	saveOfferToFirebase,
} from "../../apiIntegration/saveOfferToFirebase";
import { toast, ToastContainer } from "react-toastify";
import AIOfferTemplatesPopup from "../../components/offerDetails/AIOfferTemplatesPopup";
import { BlinkBlur } from "react-loading-indicators";

export default function ShopOfferCreateScreen() {
	const navigate = useNavigate();

	const [form, setForm] = useState({
		title: "",
		description: "",
		instagramLink: "",
		category: "Fashion",
		offerValue: "",
		offerType: "Percent",
		subCategoryType: "",
		originalPrice: "",
		discountedPrice: "",
		minOrderValue: "",
		maxDiscount: "",
		terms: [],
		startDate: "",
		endDate: "",
		offerLongDetails: "",
	});

	const [imageFile, setImageFile] = useState(null);
	const [previewUrl, setPreviewUrl] = useState("");
	const [step, setStep] = useState(1);
	const [loading, setLoading] = useState(false);
	const [templateType, setTemplateType] = useState("dark");
	const [selectedImage, setSelectedImage] = useState(null);
	const [showCropper, setShowCropper] = useState(false);

	const [showAiPopup, setShowAiPopup] = useState(false);
	const [aiTriggered, setAiTriggered] = useState(false);
	const [offerMedia, setOfferMedia] = useState([]);
	const shopDetails = getShopDetailsFromLocalStorage();
	useEffect(() => {
		if (!shopDetails?.shopId) {
			navigate("/login-screen", { replace: true });
		}
	}, [navigate]);

	/* ================= HANDLE INPUT ================= */
	const handleChange = (e) => {
		const updated = { ...form, [e.target.name]: e.target.value };
		setForm(updated);

		if (updated.title && updated.description && updated.offerValue) {
			setStep(2);
		}
		if (updated.startDate && updated.endDate) {
			setStep(3);
		}
	};

	/* ================= IMAGE ================= */
	const handleImageUpload = (e) => {
		const file = e.target.files[0];
		if (!file) return;

		const url = URL.createObjectURL(file);

		setSelectedImage(url); // open cropper
		setShowCropper(true);
		setStep(3);
	};

	const handleCropDone = (blob) => {
		const preview = URL.createObjectURL(blob);

		setPreviewUrl(preview); // show preview
		setImageFile(blob); // 🔥 upload cropped image
	};

	// ==================== AI PART ==================

	// const handleSelectTemplate = async (template) => {
	// 	try {
	// 		setForm((prev) => ({
	// 			...prev,
	// 			title: template.title,
	// 			description: template.shortDescription,
	// 			offerLongDetails: template.longDescription,
	// 		}));

	// 		setPreviewUrl(template.image);

	// 		/* ======================================================
	// 	   CONVERT IMAGE URL TO FILE
	// 	====================================================== */

	// 		const response = await fetch(template.image);

	// 		const blob = await response.blob();

	// 		const file = new File([blob], "offer-image.jpg", {
	// 			type: blob.type,
	// 		});

	// 		setImageFile(file);

	// 		setShowAiPopup(false);
	// 		setAiTriggered(false);
	// 	} catch (error) {
	// 		console.log(error);
	// 	}
	// };

	/* ================= TERMS ================= */
	const addTerm = () => {
		setForm({ ...form, terms: [...form.terms, ""] });
	};

	const updateTerm = (index, value) => {
		const updated = [...form.terms];
		updated[index] = value;
		setForm({ ...form, terms: updated });
	};

	const removeTerm = (index) => {
		const updated = form.terms.filter((_, i) => i !== index);
		setForm({ ...form, terms: updated });
	};

	/* ================= VALIDATION ================= */
	const validateForm = () => {
		if (!form.title || !form.description) {
			alert("Fill offer details");
			return false;
		}
		if (!form.endDate) {
			alert("Select dates");
			return false;
		}
		if (!imageFile) {
			alert("Upload image");
			return false;
		}
		return true;
	};

	/* ================= PUBLISH ================= */
	const publishOffer = async () => {
		if (!validateForm()) return;

		const normalizedOfferType = form.offerType?.toLowerCase();

		if (
			(normalizedOfferType === "percent" ||
				normalizedOfferType === "flat") &&
			!form.offerValue
		) {
			toast.error("Offer value is required for Percent or Flat offers");

			return;
		}

		try {
			setLoading(true);
			/* ================= CHECK LIMIT FIRST ================= */

			// upload sample iamge
			await checkShopOfferLimit(shopDetails.shopId);
			const mediaUrls = await Promise.all(
				offerMedia.map(async (item) => {
					const url = await uploadImageToCloudinaryStorage(item.file);

					return {
						type: item.type,
						url,
					};
				}),
			);

			const imageUrl = await uploadImageToCloudinaryStorage(imageFile);
			const offerId = `offer_${Date.now()}`;
			const data = {
				shopId: shopDetails.shopId,
				shopName: shopDetails.shopName,
				shopPhone: shopDetails.phone,
				shopAddress: shopDetails.address,
				offerId: offerId,
				title: form.title,
				description: form.description,
				offerLongDetails: form.offerLongDetails,
				instagramLink: form.instagramLink,
				category: shopDetails.category,
				subCategory: form.subCategoryType,
				offerType: form.offerType.toLowerCase(),
				offerValue: Number(form.offerValue),
				pricing: {
					originalPrice: Number(form.originalPrice),
					discountedPrice: Number(form.discountedPrice),
					minOrderValue: Number(form.minOrderValue || 0),
					maxDiscount: Number(form.maxDiscount || 0),
				},
				terms: form.terms,
				startDate: form.startDate,
				endDate: form.endDate,
				startsAt: new Date(form.startDate).setHours(0, 0, 0, 0),
				expiresAt: new Date(form.endDate).setHours(23, 59, 59, 999),
				image: imageUrl,
				status: "active",

				geoHash: shopDetails.geoHash,
				location: shopDetails.location,
				createdAt: new Date().toISOString(),
				offerTemplate: templateType,
				media: mediaUrls,
			};

			await saveOfferToFirebase(data);

			alert("Offer Published 🚀");
			navigate(-1);
		} catch (err) {
			console.error(err);

			if (err.message === "MAX_OFFER_LIMIT") {
				toast.error(
					"You can only create maximum 2 offers with one account",
				);
			} else {
				toast.error("Failed to publish offer");
			}
		} finally {
			setLoading(false);
		}
	};

	if (loading) {
		return (
			<div className="px-3 mt-5 nearBuSection">
				<BlinkBlur
					color="#494949"
					size="medium"
					text="Loading offers..."
					textColor="#ffffff"
				/>
			</div>
		);
	}

	return (
		<div className="app">
			{/* HEADER */}
			<ToastContainer
				position="top-right"
				autoClose={3000}
				hideProgressBar={false}
				closeOnClick
				pauseOnHover
				theme="light"
			/>
			{/* STEPPER */}
			<div className="stepper">
				<div className={`step ${step >= 1 ? "active" : ""}`}>1</div>
				<div className={`line ${step >= 2 ? "active" : ""}`}></div>
				<div className={`step ${step >= 2 ? "active" : ""}`}>2</div>
				<div className={`line ${step >= 3 ? "active" : ""}`}></div>
				<div className={`step ${step >= 3 ? "active" : ""}`}>3</div>
			</div>

			<div className="section">
				{/* ================= DETAILS ================= */}
				<h6>Offer Details</h6>
				<CreateOfferDetailsComp
					form={form}
					handleChange={handleChange}
					shopDetails={shopDetails}
					setShowAiPopup={setShowAiPopup}
					setAiTriggered={setAiTriggered}
					offerMedia={offerMedia}
					setOfferMedia={setOfferMedia}
				/>

				{/* PRICING */}
				<CreatePricingDetailsComp
					form={form}
					handleChange={handleChange}
				/>

				{/* TERMS */}
				<TermsAndConditionsComp
					form={form}
					updateTerm={updateTerm}
					removeTerm={removeTerm}
					addTerm={addTerm}
				/>

				{/* ================= VALIDITY ================= */}
				<ValidityComp form={form} handleChange={handleChange} />

				{/* ================= IMAGE ================= */}
				<div className="card-box upload-box text-center">
					<div>
						<i className="fas fa-upload fa-2x"></i>
					</div>
					<div>
						<label className="">
							<p className="mt-2 mb-0">Upload Image</p>
							<span className="text-muted">JPG / PNG</span>
							<input
								type="file"
								onChange={handleImageUpload}
								hidden
							/>
						</label>
					</div>
					<small>Recommended 1080x1080px</small>
				</div>

				{/* =================  PREVIEW sample offer tempalte =================  */}

				{showCropper && (
					<ImageCropper
						image={selectedImage}
						onCropDone={handleCropDone}
						onClose={() => setShowCropper(false)}
					/>
				)}
				<div>
					<OfferTemplateRenderer
						data={form}
						type={templateType}
						previewUrl={previewUrl}
					/>
				</div>		

				{/* =================  PREVIEW sample offer details =================  */}

				<CreateOfferDetailsInfoPreview form={form} />

				{/* ================= ACTIONS ================= */}
				<div className="actions">
					<button
						onClick={publishOffer}
						className="btn btn-primary w-100"
						disabled={loading}
					>
						{loading ? "Publishing..." : "Publish Offer"}
					</button>
				</div>
			</div>
		</div>
	);
}
